export default __webpack_public_path__ + "b371e22.png";